import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const DelegateManager = (props) => {
  const { onChangeFunction, disabled, id, empId, managerLookupDefaultValue } = props;

  const appconfig = useSelector((state) => state.appConfig);

  const { t, i18n } = useTranslation();

 

  let managerEmailOptions;

  if (appconfig && appconfig?.managerEmails) {
    
    //added filter to remove the current selected worker from the dropdown, if he/she is also an approver
    let filterOutTheCurrentEditingWorkerName = appconfig.managerEmails.filter(
      (item) => item.managerId !== empId
    );
    //filter out the manager who is on employee look up
    managerEmailOptions = filterOutTheCurrentEditingWorkerName.filter(item => item.managerId!==managerLookupDefaultValue)

  }

  
  const getDefaultOptions = () => {
    let arrayForDefault = [];
    let index;
    if (id && id.length) {
      for (let i = 0; i < id.length; i++) {
        index = managerEmailOptions.findIndex((option) => {
          return option.managerId == id[i];
        });
        if (index !== -1) {
          arrayForDefault.push(managerEmailOptions[index]);
        }
      }
    }
    return arrayForDefault;
  };

  return (
    <>
      {managerEmailOptions && (
        <Autocomplete
          id="delegate"
          multiple
          disabled={disabled}
          options={managerEmailOptions}
          onBlur={onChangeFunction}
          onChange={onChangeFunction}
          defaultValue={getDefaultOptions()}
          getOptionLabel={(option) =>
            option && option.managerFirstName
              ? `${option.managerFirstName} ${option.managerLastName} (${option.managerId})`
              : ""
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              label={t("other.approvingManager")}
            />
          )}
        />
      )}
    </>
  );
};

export default DelegateManager;
